import { FormattedMessage } from 'react-intl'

import Box, { BoxProps } from 'app/components/base/Box'
import Text from 'app/components/base/Text'
import Hint from 'app/components/common/Hint'

const SellerHolidayHint: RFC<{
  visible?: boolean
  sx?: BoxProps['sx']
}> = ({ visible, sx }) => {
  if (!visible) return null

  return (
    <Box
      sx={{
        width: '100%',
        pb: { md: 3, xs: 2 },
        ...sx
      }}
    >
      <Hint sx={{ width: '100%' }}>
        <Text>
          <FormattedMessage defaultMessage="Seller on holidays now. You can add item to My Garage and check it later." />
        </Text>
      </Hint>
    </Box>
  )
}

export default SellerHolidayHint
